



























import { accountService } from '@/services'
import { Page } from '@/types/enums'
import { JumpLink, StaticJumpLink } from '@/types/JumpLinksType'
import Vue from 'vue'

export default Vue.extend({
    name: 'JumpLinks',
    props: {
        links: {
            type: Array as () => JumpLink[],
            required: true
        },
        page: {
            type: String,
            required: true
        },
        referenceObj: {
            type: Object,
            required: true
        },
        staticJumpLinks: {
            type: Array as () => StaticJumpLink[],
            required: false
        }
    },
    data() {
        return {
            pageConfigMap: {
                [Page.PROPERTY_INFORMATION]: Page.PROPERTY,
                [Page.TENANT]: Page.TENANTS
            } as Record<string, string>,
            fieldsMap: {} as Record<string, string>,
        }
    },
    methods:{
        back(){
            this.$router.go(-1)
        },
        async generateFieldsMap(page: string, links: JumpLink[]) {
            if(page && links.length > 0) {
                const pageConfig = await accountService.GetPageConfig(this.pageConfigMap[page] ?? page)
                this.fieldsMap = pageConfig.fields.reduce((acc, field) => {
                    acc[field.alias] = field.key
                    return acc
                }, {} as Record<string, string>)

            }
        }
    },
    watch: {
        async page(newVal, oldVal) {
            if(newVal !== oldVal && newVal) {
                await this.generateFieldsMap(newVal, this.links)
            }
        },
        async links(newVal, oldVal) {
            if(newVal !== oldVal && newVal.length > 0) {
                await this.generateFieldsMap(this.page, newVal)
            }
        }
    },
    computed: {
        filtered():any {
            return this.links.reduce((acc, link) => {
                if(link.location === this.page) {
                    let shouldInclude = true
                    const jumpLink = {
                        label: link.label,
                        value: link.parts.map( part => {
                            if(part.type === 'dropdown') {
                                const fieldKey = this.fieldsMap[part.value]
                                const referenceValue = this.referenceObj[fieldKey] ?? ''
                                if(referenceValue === '') {
                                    shouldInclude = false
                                }

                                return referenceValue
                            } else {
                                return part.value
                            }
                        }).join('')
                    }

                    if(shouldInclude) {
                        acc.push(jumpLink)
                    }
                }

                return acc
            }, [] as {label:string,value:string}[])
        }
    }
})
